module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('nav', {
    staticClass: "c-nav-menu"
  }, [_c('button', {
    class: ("c-nav-menu__button " + _vm.activeClass),
    on: {
      "click": function($event) {
        _vm.$emit('toggleNav')
      }
    }
  }, [_vm._m(0, false, false), _vm._v(" "), _c('span', {
    staticClass: "c-nav-menu__button-text"
  }, [_vm._v("Menu")])]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "slide"
    }
  }, [(_vm.isOpen) ? _c('div', {
    staticClass: "c-nav-menu__items-wrapper"
  }, [_c('div', {
    staticClass: "c-nav-menu__items"
  }, [_c('div', {
    staticClass: "c-nav-menu__items-scroll"
  }, [_c('a', {
    staticClass: "c-nav-menu__logo logo",
    attrs: {
      "href": "//litera.com/",
      "rel": "nofollow",
      "alt": "Browse back to litera.com",
      "target": "_self"
    }
  }, [_c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 288 21.2"
    }
  }, [_c('path', {
    attrs: {
      "d": "M36.7 4.8c0-.2.2-.4.4-.4h2.1c.2 0 .4.2.4.4v13h5.9c.3 0 .4.2.4.4v1.9c0 .2-.2.4-.4.4H37c-.3 0-.4-.2-.4-.4l.1-15.3zm11.7 0c0-.2.2-.4.4-.4H51c.2 0 .4.2.4.4v15.4c0 .2-.2.4-.4.4h-2.2c-.2 0-.4-.2-.4-.4V4.8zm9.5 2.3h-3.6c-.3 0-.4-.2-.4-.4V4.8c0-.2.2-.4.4-.4h10.2c.3 0 .4.2.4.4v1.9c0 .2-.2.4-.4.4h-3.6v13c0 .2-.2.4-.4.4h-2.2c-.2 0-.4-.2-.4-.4v-13zm9.4-2.3c0-.2.2-.4.4-.4h9.5c.3 0 .4.2.4.4v1.9c0 .2-.2.4-.4.4h-6.9V11H76c.2 0 .4.2.4.4v1.9c0 .3-.2.4-.4.4h-5.7v4.1h6.9c.3 0 .4.2.4.4v1.9c0 .2-.2.4-.4.4h-9.5c-.3 0-.4-.2-.4-.4V4.8zm13.7 0c0-.2.2-.4.4-.4H88c2.8 0 5.1 2.2 5.1 5 0 2.1-1.4 3.9-3.4 4.7l3.2 5.9c.2.3 0 .7-.4.7h-2.4c-.2 0-.3-.1-.4-.2l-3.1-6.2H84v5.9c0 .2-.2.4-.4.4h-2.1c-.3 0-.4-.2-.4-.4L81 4.8zm6.8 7c1.2 0 2.3-1.1 2.3-2.4 0-1.2-1.1-2.3-2.3-2.3H84v4.6h3.8v.1zm6.6 8.2l7.2-15.6c.1-.1.2-.3.4-.3h.2c.2 0 .3.1.4.3l7.2 15.6c.1.3 0 .6-.4.6h-2c-.3 0-.5-.1-.7-.5l-1.1-2.5h-7l-1.1 2.5c-.1.2-.3.5-.7.5h-2c-.4 0-.6-.3-.4-.6zm10-4.9l-2.3-5.1h-.1l-2.3 5.1h4.7zm14.5-10.6c0-.2.2-.3.4-.3h.4c.1 0 .3.1.4.3l4.9 11.9h.1l4.8-11.9c0-.1.2-.3.4-.3h.4c.2 0 .4.2.4.3l2.9 15.6c.1.3-.1.5-.4.5H132c-.2 0-.4-.2-.4-.3l-1.7-10.4h-.1l-4.2 10.7c0 .1-.2.3-.4.3h-.4c-.2 0-.3-.1-.4-.3l-4.2-10.7h-.1l-1.7 10.4c0 .2-.2.3-.4.3h-1.5c-.3 0-.5-.2-.4-.5l2.8-15.6zm18.5.3c0-.2.2-.4.4-.4h1.5c.2 0 .4.2.4.4v15.4c0 .2-.2.4-.4.4h-1.5c-.2 0-.4-.2-.4-.4V4.8zm14.1-.7c2.3 0 4 .8 5.6 2.2.2.2.2.5 0 .7l-1 1c-.2.2-.4.2-.6 0-1.1-1-2.6-1.6-4-1.6-3.3 0-5.8 2.8-5.8 6s2.5 6 5.9 6c1.7 0 2.9-.7 4-1.5.2-.2.4-.1.6 0l1.1 1c.2.2.1.5 0 .6-1.6 1.5-3.6 2.3-5.7 2.3-4.6 0-8.4-3.7-8.4-8.3s3.6-8.4 8.3-8.4zm9 .7c0-.2.2-.4.4-.4h6.3c2.8 0 5.1 2.2 5.1 5 0 2.1-1.4 3.9-3.4 4.7L172 20c.2.3 0 .7-.4.7h-1.8c-.2 0-.3-.1-.4-.2l-3.1-6.2h-3.5v5.9c0 .2-.2.4-.4.4h-1.5c-.3 0-.4-.2-.4-.4V4.8zm6.6 7.5c1.5 0 2.8-1.3 2.8-2.9 0-1.5-1.3-2.8-2.8-2.8H163v5.6h4.1v.1zm16-8.2c4.7 0 8.4 3.7 8.4 8.4s-3.7 8.3-8.4 8.3c-4.6 0-8.3-3.7-8.3-8.3s3.6-8.4 8.3-8.4zm0 14.4c3.3 0 6-2.7 6-6s-2.7-6.1-6-6.1-6 2.8-6 6.1 2.7 6 6 6zm10.6-.2c.2-.3.4-.7.6-1 .2-.3.5-.4.8-.2.1.1 1.9 1.6 3.7 1.6 1.6 0 2.6-1 2.6-2.2 0-1.4-1.2-2.3-3.5-3.2-2.4-1-4.2-2.2-4.2-4.9 0-1.8 1.4-4.3 5.1-4.3 2.3 0 4.1 1.2 4.3 1.4.2.1.4.4.1.8l-.6.9c-.2.3-.5.4-.8.2-.2-.1-1.8-1.2-3.1-1.2-2 0-2.6 1.2-2.6 2.1 0 1.3 1 2.1 3 2.9 2.7 1.1 5 2.4 5 5.2 0 2.4-2.2 4.4-5.2 4.4-2.8 0-4.6-1.5-5-1.8-.2-.2-.4-.3-.2-.7zm16.8-5.5L205 5c-.2-.3 0-.7.4-.7h1.7c.2 0 .3.1.4.2l4.2 5.9 4.2-5.9c.1-.1.2-.2.4-.2h1.7c.4 0 .6.4.4.7l-5.5 7.7v7.4c0 .2-.2.4-.4.4H211c-.3 0-.4-.2-.4-.4l-.1-7.3zm9.1 5.5c.2-.3.4-.7.6-1 .2-.3.5-.4.8-.2.1.1 1.9 1.6 3.7 1.6 1.6 0 2.6-1 2.6-2.2 0-1.4-1.2-2.3-3.5-3.2-2.4-1-4.2-2.2-4.2-4.9 0-1.8 1.4-4.3 5.1-4.3 2.3 0 4.1 1.2 4.3 1.4.2.1.4.4.1.8l-.6.9c-.2.3-.5.4-.8.2-.2-.1-1.8-1.2-3.1-1.2-2 0-2.6 1.2-2.6 2.1 0 1.3 1 2.1 3 2.9 2.7 1.1 5 2.4 5 5.2 0 2.4-2.2 4.4-5.2 4.4-2.8 0-4.6-1.5-5-1.8-.3-.2-.5-.3-.2-.7zm15.7-11.8h-3.8c-.3 0-.4-.2-.4-.4V4.8c0-.2.2-.4.4-.4h10c.3 0 .4.2.4.4v1.3c0 .2-.2.4-.4.4h-3.8v13.6c0 .2-.2.4-.4.4h-1.5c-.2 0-.4-.2-.4-.4V6.5h-.1zm9.2-1.7c0-.2.2-.4.4-.4h9.3c.3 0 .4.2.4.4v1.3c0 .2-.2.4-.4.4h-7.3v4.7h6.2c.2 0 .4.2.4.4V13c0 .3-.2.4-.4.4h-6.2v5h7.3c.3 0 .4.2.4.4v1.3c0 .2-.2.4-.4.4h-9.3c-.3 0-.4-.2-.4-.4V4.8zm15.4-.3c0-.2.2-.3.4-.3h.4c.1 0 .3.1.4.3l4.9 11.9h.1l4.8-11.9c0-.1.2-.3.4-.3h.4c.2 0 .4.2.4.3l2.9 15.6c.1.3-.1.5-.4.5H273c-.2 0-.4-.2-.4-.3l-1.7-10.4h-.1l-4.2 10.7c0 .1-.2.3-.4.3h-.4c-.2 0-.3-.1-.4-.3l-4.2-10.7h-.1l-1.7 10.4c0 .2-.2.3-.4.3h-1.5c-.3 0-.5-.2-.4-.5l2.8-15.6zm17.4 13.8c.2-.3.4-.7.6-1s.5-.4.8-.2c.1.1 1.9 1.6 3.7 1.6 1.6 0 2.6-1 2.6-2.2 0-1.4-1.2-2.3-3.5-3.2-2.4-1-4.2-2.2-4.2-4.9 0-1.8 1.4-4.3 5.1-4.3 2.3 0 4.1 1.2 4.3 1.4.2.1.4.4.1.8l-.6.9c-.2.3-.5.4-.8.2-.2-.1-1.8-1.2-3.1-1.2-2 0-2.6 1.2-2.6 2.1 0 1.3 1 2.1 3 2.9 2.7 1.1 5 2.4 5 5.2 0 2.4-2.2 4.4-5.2 4.4-2.8 0-4.6-1.5-5-1.8-.2-.2-.4-.3-.2-.7z"
    }
  }), _c('path', {
    attrs: {
      "fill": "#f26924",
      "d": "M17.4.3c-1.3 0-1.9 1.1-1.3 2.3l8.4 18h6c1.3 0 1.9-1.1 1.3-2.3L23.4.3h-6z"
    }
  }), _c('path', {
    attrs: {
      "fill": "#fdb714",
      "d": "M8.2 6.7l6.5 13.9h6c1.3 0 1.9-1.1 1.3-2.3l-6.6-14h-6c-1.3 0-1.8 1.1-1.2 2.4z"
    }
  }), _c('path', {
    attrs: {
      "fill": "#00a176",
      "d": "M.6 11.9l4.1 8.7h6c1.3 0 1.9-1.1 1.3-2.3L7.9 9.6h-6c-1.3 0-1.9 1-1.3 2.3z"
    }
  })])]), _vm._v(" "), _c('h3', {
    staticClass: "c-nav-menu__item-contents"
  }, [_vm._v("Contents")]), _vm._v(" "), _c('nav-menu-category', {
    attrs: {
      "category": "Leadership",
      "posts": _vm.posts
    }
  }), _vm._v(" "), _c('nav-menu-category', {
    attrs: {
      "category": "Legal Market",
      "posts": _vm.posts
    }
  }), _vm._v(" "), _c('nav-menu-category', {
    attrs: {
      "category": "Legal Tech",
      "posts": _vm.posts
    }
  }), _vm._v(" "), _c('nav-menu-category', {
    attrs: {
      "category": "Management",
      "posts": _vm.posts
    }
  })], 1), _vm._v(" "), (['post'].indexOf(_vm.$route.name) > -1) ? _c('router-link', {
    staticClass: "c-home-button",
    attrs: {
      "to": {
        name: 'homepage'
      }
    }
  }, [_c('svg', {
    staticClass: "c-home-button__icon",
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "14",
      "height": "14",
      "viewBox": "0 0 32 32"
    }
  }, [_c('path', {
    attrs: {
      "d": "M0 16c0 0.3 0.1 0.5 0.3 0.7l9.9 10c0.4 0.4 1 0.4 1.4 0 0.4-0.4 0.4-1 0-1.4L3.4 17H31c0.6 0 1-0.5 1-1s-0.4-1-1-1H3.4l8.2-8.3c0.4-0.4 0.4-1 0-1.4 -0.4-0.4-1-0.4-1.4 0l-9.9 10C0.1 15.5 0 15.7 0 16z",
      "fill": "#121313"
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "c-home-button__text"
  }, [_vm._v("Back to Cover")])]) : _vm._e()], 1)]) : _vm._e()])], 1), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fadeIn"
    }
  }, [(_vm.isOpen) ? _c('div', {
    staticClass: "nav-underlay",
    on: {
      "click": function($event) {
        _vm.$emit('toggleNav')
      }
    }
  }) : _vm._e()])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "c-nav-menu__button-box"
  }, [_c('div', {
    staticClass: "c-nav-menu__button-inner"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5f206bb3"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/NavMenu.vue
// module id = 82
// module chunks = 0